<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4 4 16 18"
  >
    <path
      id="Path_1380"
      data-name="Path 1380"
      class="cls-1"
      d="M7.27,13l2.9,3.1,6.6-6.3"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon',
};
</script>
<style lang="scss" scoped>
svg {
  fill: none;
  stroke: main.$npGray;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.75px;
}
</style>
